import N8nRoute from './Route.vue';
export default N8nRoute;
